// scroll animation
$(function(){
    // disable on mobile
    if($(window).width() < 769) {
        return false;
    }
    // scene per section
    // section #coral-reef-rescue-is
    let tlCor = new TimelineMax();
    tlCor.from($('#coral-reef-rescue-is h3'), 2, { yPercent: 100, rotation: 0.01, opacity: 0 }, "start");
    tlCor.from($('#coral-reef-rescue-is .content'), 2, { yPercent: 170, rotation: 0.01, opacity: 0 }, "start");

    scenes.push(function() {
        return new ScrollMagic.Scene({ 
            offset: 200, 
            triggerHook: "onEnter", 
            triggerElement: '#coral-reef-rescue-is', 
            duration: sceneDuration, 
            reverse:true 
        })
        .setTween(tlCor)
        .addTo(controller);
    });

    // section climate-change 
    if($(window).width() > 991 && !isIE) {
        // console.log(headerHeight);
        scenes.push(function() {
            new ScrollMagic.Scene({
                offset: -headerHeight,
                triggerElement: '#climate-change .content',
                triggerHook: "onLeave",
                duration: sceneDuration*2,
                // reverse: false
            })
            .setClassToggle("#climate-change .content", "fixed-el")
            .on("start", function(e){
                $("#climate-change .content").css('top', scrollbar.scrollTop + 'px');
                if(e.scrollDirection == "REVERSE") {
                    $("#climate-change .content").removeAttr('style');
                }
            })
            .addTo(controller);
        });

        scenes.push(function() {
            new ScrollMagic.Scene({
                triggerElement: '#climate-change .fixed-banner',
                triggerHook: "onLeave",
                duration: sceneDuration*2,
                reverse: true
            })
            .setClassToggle("#climate-change .fixed-banner", "fixed-el")
            .on("start", function(e){
                $("#climate-change .fixed-banner").css('top', scrollbar.scrollTop + 'px');
                if(e.scrollDirection == "REVERSE") {
                    $("#climate-change .fixed-banner").css('top', 'unset');
                }
            })
            .addTo(controller);
        });
    }

    // section #coral-reef-rescue-is
    let tlClimOrnament = new TimelineMax();
    tlClimOrnament.from($('#climate-change .ornament--coral-oval'), 1, { yPercent: 300, rotation: 0.01 }, "start");
    tlClimOrnament.from($('#climate-change .ornament--plus'), 1, { yPercent: 400, rotation: 0.01 }, "start");

    scenes.push(function() {
        return new ScrollMagic.Scene({   
            triggerHook: "onEnter", 
            triggerElement: '#climate-change .fixed-banner', 
            duration: sceneDuration*2, 
            reverse:true 
        })
        .setTween(tlClimOrnament)
        .addTo(controller);
    });

    if($(window).width() > 991 && !isIE) {
        let tlClim = new TimelineMax();
        tlClim.to($('#climate-change .content'), 1, { xPercent: -50, rotation: 0.01 }, "start");
        tlClim.to($('#climate-change .fixed-banner .banner2'), 2, { opacity: 0, rotation: 0.01 }, "start");
        tlClim.to($('#climate-change .container'), 1.5, { opacity: 0 }, "start");
        tlClim.to($('#climate-change .ornament'), .5, { opacity: 0 }, "start");
        
        scenes.push(function() {
            new ScrollMagic.Scene({   
                triggerHook: "onLeave", 
                triggerElement: '#climate-change .fixed-banner', 
                duration: sceneDuration*2, 
                reverse:true 
            })
            .setTween(tlClim)
            .addTo(controller);
        });

    } else {
        // our #resilient-reef 
        let tlClim = new TimelineMax();
        let contentResReef = sceneDuration - $('#climate-change .content').height();
        tlClim.from($('#climate-change .content'), 1, { y: contentResReef, rotation: 0.01 }, "start");

        scenes.push(function() {
            new ScrollMagic.Scene({   
                triggerHook: "onEnter", 
                triggerElement: '#climate-change', 
                duration: sceneDuration*2, 
                reverse:true 
            })
            .setTween(tlClim)
            .addTo(controller);
        });
    }

    // section act-now
    // fixed element
    if($(window).width() > 991 && !isIE) {
        scenes.push(function() {
            new ScrollMagic.Scene({
                triggerElement: '#act-now .fixed-banner',
                triggerHook: "onLeave",
                duration: sceneDuration,
            })
            .setClassToggle("#act-now .fixed-banner", "fixed-el")
            .on("start", function(e){
                $("#act-now .fixed-banner").css('top', scrollbar.scrollTop + 'px');
                
                if(e.scrollDirection == "REVERSE") {
                    $("#act-now .fixed-banner").css('top', 'unset');
                }
            })
            .addTo(controller);
        });
    }

    // our goal 
    let tlOurGoalOrnament = new TimelineMax();
    tlOurGoalOrnament.from($('#our-goal .ornament--fork'), 1, { yPercent: 400, rotation: 0.01 }, "start");
    tlOurGoalOrnament.from($('#our-goal .ornament--arrow'), 1, { yPercent: -500, rotation: 0.01 }, "start");

    scenes.push(function() {
        return new ScrollMagic.Scene({   
            triggerHook: "onEnter", 
            triggerElement: '#our-goal', 
            duration: sceneDuration*2, 
            reverse:true 
        })
        .setTween(tlOurGoalOrnament)
        .addTo(controller);
    });

    let tlAct = new TimelineMax();
    tlAct.from($('#act-now .fixed-banner h2'), 2, { opacity: 0 }, "start");
    tlAct.from($('#act-now .fixed-banner .ornament'), .5, { opacity: 0 }, "start");
 
    scenes.push(function() {
        return new ScrollMagic.Scene({   
            triggerHook: ($(window).width() > 991 && !isIE)? "onLeave": .5, 
            triggerElement: '#act-now .fixed-banner', 
            duration: sceneDuration, 
            reverse:true 
        })
        .setTween(tlAct)
        .addTo(controller)
    });

    // section #climate-change-is-not
    let tlClimisNot = new TimelineMax();
    tlClimisNot.from($('#climate-change-is-not h3'), 2, { yPercent: 100, rotation: 0.01, opacity: 0 }, "start");
    tlClimisNot.from($('#climate-change-is-not .content'), 2, { yPercent: 170, rotation: 0.01, opacity: 0 }, "start");

    scenes.push(function() {
        return new ScrollMagic.Scene({ 
            offset: 200, 
            triggerHook: "onEnter", 
            triggerElement: '#climate-change-is-not', 
            duration: sceneDuration, 
            reverse:true 
        })
        .setTween(tlClimisNot)
        .addTo(controller);
    });

    // if($(window).width() > 991) {
        // our #resilient-reef 
        let tlResReef = new TimelineMax();
        let contentResReef = $('#resilient-reef').height() - $('#resilient-reef .content').height();
        tlResReef.from($('#resilient-reef .ornament--wave'), 1, { yPercent: 400, rotation: 0.01 }, "start");
        tlResReef.from($('#resilient-reef .ornament--coral'), 1, { yPercent: 500, rotation: 0.01 }, "start");
        tlResReef.from($('#resilient-reef .content'), 1, { y: contentResReef, rotation: 0.01 }, "start");

        scenes.push(function() {
            new ScrollMagic.Scene({   
                triggerHook: "onEnter", 
                triggerElement: '#resilient-reef', 
                duration: sceneDuration*2, 
                reverse:true 
            })
            .setTween(tlResReef)
            .addTo(controller);
        });

        // our #resilient-communities 
        let tlResCom = new TimelineMax();
        let contentResCom = $('#resilient-communities').height() - $('#resilient-communities .content').height();
        tlResCom.from($('#resilient-communities .ornament--coral-oval'), 1, { yPercent: 400, rotation: 0.01 }, "start");
        tlResCom.from($('#resilient-communities .ornament--plus'), 1, { yPercent: 500, rotation: 0.01 }, "start");
        tlResCom.from($('#resilient-communities .content'), 1, { y: contentResCom, rotation: 0.01 }, "start");

        scenes.push(function() {
            new ScrollMagic.Scene({   
                triggerHook: "onEnter", 
                triggerElement: '#resilient-communities', 
                duration: sceneDuration*2, 
                reverse:true 
            })
            .setTween(tlResCom)
            .addTo(controller);
        });
    // }

    // Get Envolved
    let tlGetEnvolved = new TimelineMax();
    tlGetEnvolved.from($('#home-get-involved .ornament--coral'), 1, { yPercent: 400, rotation: 0.01 }, "start");
    tlGetEnvolved.from($('#home-get-involved .ornament--turtle'), 1, { yPercent: 500, rotation: 0.01 }, "start");

    scenes.push(function() {
        return new ScrollMagic.Scene({   
            triggerHook: "onEnter", 
            triggerElement: '#home-get-involved', 
            duration: sceneDuration*2, 
            reverse:true 
        })
        .setTween(tlGetEnvolved)
        .addTo(controller);
    });

    // listener smooth-scrollbar, update controller
    function addScenes(newScenes) {
        // reset active scenes
        activeScenes = [];
        // loop over each scene and add/re-add
        newScenes.forEach(function (newScene, index) {
          if (typeof newScene === 'function') {
            // add the new scene
            var newScene = newScene();
            // push it to our active scenes array
            activeScenes.push(newScene);
          }
        });
    }
 
    scrollbar.addListener(function(status) {
        y = status.offset.y;

        $('.fixed-el').each(function (index, element) {
            $(this).css('top', y + 'px');
        });
    });

    $(window).on('resize', function(e) {
        sceneDuration = $(window).height();
        headerHeight = $('header').height();
        // addScenes(scenes);  
        controller.update();
    });
    
    // add initial scenes
    addScenes(scenes);    
});

var startW = $(window).width(); // width before resize
var startH = $(window).height(); 
var resizeW = startW;
var resizeH = startH;

var resizeTimer;

$(window).on('resize', function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        resizeW = $(window).width(); // width after resize
        resizeH = $(window).height(); // width after resize
        if (startW < 768) {
            if (resizeW > 768) {
                window.location.href = window.location;
                // console.log('below '+startW, resizeW);
            }
        } else {
            // console.log('up '+startW, resizeW);
            if(startH !== resizeH) {
                window.location.href = window.location;
            }

            if(startW > 992 && resizeW <= 992) {
                window.location.href = window.location;
            }

            if(startW < 992 && resizeW >= 992) {
                window.location.href = window.location;
            }
        }
  }, 250);
});

// $(window).bind('resize', function(e){
//     window.resizeEvt;
//     $(window).resize(function(){
        
//         clearTimeout(window.resizeEvt);
//         window.resizeEvt = setTimeout(function(){
//             resizeW = $(window).width(); // width after resize
//             if (startW < 768) {
//                 if (resizeW > 768) {
//                     window.location.href = window.location;
//                     // console.log('below '+startW, resizeW);
//                 }
//             } else {
//                 // console.log('up '+startW, resizeW);
//                 window.location.href = window.location;
//             }
//         }, 250);
//     });
// });
